var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"0.849121","y1":"15.142","x2":"14.9913","y2":"0.999879","stroke":"black","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"0.5","y1":"-0.5","x2":"20.5","y2":"-0.5","transform":"matrix(-0.707107 -0.707107 -0.707107 0.707107 14.8491 15.8496)","stroke":"black","strokeLinecap":"round","key":1})]);
}

Cross.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
